import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(26, 26, 26, 0.71);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  .modalContainer {
    width: 27.5rem;
    height: 39rem;
    border-radius: 2rem;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.35) 0 0.3125rem 0.9375rem;
    display: flex;
    flex-direction: column;
    padding: 0.625rem 2.25rem;
  }

  .modalContainer {
    display: inline-block;
    text-align: center;
    margin-top: 0.625rem;
  }

  .titleCloseBtn {
    display: flex;
    justify-content: flex-end;
  }

  .titleCloseBtn button {
    background-color: transparent;
    border: none;
    font-size: 25px;
    cursor: pointer;
  }

  .modalContainer .body {
    flex: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.7rem;
    text-align: center;
  }

  .modalContainer .footer {
    flex: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modalContainer .footer button {
    width: 9.375rem;
    height: 2.8125rem;
    margin: 0.625rem;
    border: none;
    background-color: cornflowerblue;
    color: white;
    border-radius: 0.5rem;
    font-size: 20px;
    cursor: pointer;
  }

  .inputEmail {
    margin: 2.8125rem 0 1.5rem 0;
    input {
      font-family: Montserrat;
    }
  }

  .SubmitContainer {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .SocialContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .ForgetContainer {
    background: transparent;
    color: #252f3e;
    font-size: 0.785rem;
    line-height: 1.25rem;
    font-weight: 700;
    border: none;
    margin: 0 auto;
    text-decoration: underline;
    font-size: 14px;
    margin: 3rem 0 2rem 0;
  }

  #cancelBtn {
    background-color: crimson;
  }
`
export const SocialWrapper = styled.div`
  margin: -1.875rem 3.125rem;
  display: flex;
  flex-direction: column;
`

export const TitleContainer = styled.div`
  width: 17.625rem;
  height: 2.625rem;
  display: inline-block;
  text-align: center;
  margin: 0.625rem 0 0 0;

  h2 {
    margin: 0 !important;
    width: 17.625rem;
    height: 2.625rem;
    font-size: 16px !important;
  }
`

export const ButtonSubmit = styled.button`
  width: 15.4375rem;
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.625rem;
  gap: 0.625rem;
  background: #252f3e;
  box-shadow: 0 0.25rem 0.25rem rgba(0, 0, 0, 0.25);
  border-radius: 1.875rem;
  color: #fff;
  margin: 0 !important;
`

export const CancelButton = styled.button`
  text-decoration: underline;
  font-size: 24px;
  margin-bottom: 1.875rem;
`
